import React from "react";

function FullLayout(props) {
  return <div style={{ height: "100vh", width: "100vw", overflow: "hidden"}}>
    {props.children}
  </div>;
}

export default FullLayout;
